<template>
  <div class="privacy-policy">
    <p class="p header" align="center" style="margin-left:0.0000pt;text-align:center;">
	<b><span>服务</span></b><b><span>协议</span></b>
</p>
<p class="MsoNormal" style="text-indent:0pt;">
	欢迎您使用创界通商标及外观设计专利咨询服务！
</p>
<p class="MsoNormal" style="text-indent:24pt;">
	<span>本服务协议是深圳市创界通科技有限公司（简称为</span><span>“创界通”）与您之间，就为您本人及/或您所代表或代理的第三方，通过使用创界通提供的创界通商标及外观设计专利咨询服务（以下简称“本服务”），进行商标注册和外观设计专利咨询服务相关事宜所订立的有效合约。</span>
</p>
<p class="MsoNormal" style="text-indent:24pt;">
	<span>本服务协议由您与创界通商标和专利服务平台（以下简称</span><span>“创界通”或“本平台”）经营者创界通共同缔结，本协议对您与创界通均具有合同效力。</span>
</p>
<p class="MsoNormal" style="text-indent:24pt;">
	在接受本服务协议并使用创界通商标和专利服务前，请您务必仔细阅读、充分理解本服务协议的全部内容，并在确认接受本服务协议后再进行后续操作。如果您对本服务协议的条款有疑问的，请向本平台咨询，本平台将向您解释条款内容。如果您不同意本服务协议的任意内容，或者无法准确理解本平台对条款的解释，请不要进行后续操作。
</p>
<p class="MsoNormal" style="text-indent:24pt;">
	<span>当您通过网络页面直接确认、接受引用本页面链接及提示遵守内容、线下签署书面协议、实际使用本服务、或以创界通认可且符合法律法规惯例的其他任一方式确认本服务协议后，即表示您已充分阅读、理解并接受本服务协议的全部内容，并与创界通达成一致，本服务协议对双方均具有法律约束力。届时您不应以未阅读本服务协议的内容或者未获得本平台对您问询的解答等理由，主张本服务协议无效，或要求撤销</span>/变更本服务协议内容。
</p>
<p class="MsoNormal">
	<b><span>第</span>1条 协议内容和效力</b>
</p>
<p class="MsoNormal">
	1.1 协议范围：考虑到互联网服务以及产品频繁迭代更新等行业特点，为了更全面地界定您与平台之间的权利义务，本协议包括我们根据法律法规规定以及本协议制定的其他政策、规则、公告声明等，以上均为本协议不可分割的组成部分，与协议正文具有同等法律效力。
</p>
<p class="MsoNormal">
	1.2 服务范围：我们可能通过不断丰富的功能界面向您提供本协议项下的平台服务，包括但不限于移动应用程序（“微信公众号”）、PC端网站、微信小程序以及其他形式。具体以我们实时发布的服务功能界面范围为准。
</p>
<p class="MsoNormal">
	1.3 修改与更新：我们有权遵照法律法规规定，在必要时修改本协议（包括适时制定并发布其他政策、规则、公告声明），更新后的协议条款将代替原来的协议并在法律规定的期限届满后正式生效，您可以在相关服务页面查阅最新版本的协议条款。本协议修改后，如果您继续使用平台服务的，即视为您已接受修改后的协议。如果您不接受修改后的协议，则您有权利停止使用平台服务。
</p>
<p class="MsoNormal">
	<b><span>第</span>2条 服务内容</b>
</p>
<p class="MsoNormal">
	（一）商标服务
</p>
<p class="MsoNormal">
	2.1 创界通商标注册服务，是指本平台向您提供的一项商标注册申请服务，包括在线提交商标注册申请、向商标局递交、跟踪及完成商标注册全流程的平台及相应的“ [商标]” 系统技术服务和支持。
</p>
<p class="MsoNormal">
	2.2 您理解并同意，您通过创界通商标服务提交的商标注册是否成功取决于商标标志本身及申请时间等因素，并最终由商标局依法审查后决定。创界通不会以任何明示或者暗示的方式担保您提交的商标注册申请能够成功，且对您的商标注册是否成功不承担法律有明确规定之外的责任。如果您要求百分之百的成功率或其他任何效果，创界通无法做出承诺，因此请您慎重考虑是否继续使用本服务。
</p>
<p class="MsoNormal">
	2.3 创界通有权对您提交的拟申请商标进行初步审核，如果认为商标本身或商标申请行为不合法或不符合商标注册申请约定，创界通有权随时终止本次商标申请服务。
</p>
<p class="MsoNormal">
	2.4 商标注册为单次服务，如您在商标审查过程中需要提起不予补正答复、注册复审、 驳回复审、异议答辩等，或需要对已申请注册的商标改变其标志的，您均应另行购买相 应的创界通服务。
</p>
<p class="MsoNormal">
	2.5 本平台有权根据业务策略，适时对商标注册服务的功能进行增加、删减、更新、调整，或取消本服务类型，具体以您使用服务当时创界通相关页面的展示为准。若您对创界通增加、删减、调整等的内容有异议的，应及时以书面形式告知创界通，并停止使用创界通商标服务；否则，将被视为您认可前述内容。
</p>
<p class="MsoNormal">
	2.6 商标注册成功后，甲方如您需进行平台备案（如亚马逊），创界通会须配合在您甲 方提供平台备案（如亚马逊）的邮件截图后提供给甲方您备案验证码。
</p>
<p class="MsoNormal">
	<span>（</span> <span>二</span> <span>）外观专利服务</span>
</p>
<p class="MsoNormal">
	2.7 创界通外观设计专利注册服务，是指创界通向您提供的一项国际外观设计专利注册申请服务，包括在线提交外观设计专利注册申请、向外观设计专利局递交、跟踪及完成外观设计专利注册全流程的平台系统及相应的“ [外观专利]”系统技术服务和支持。
</p>
<p class="MsoNormal">
	2.8 您理解并同意，您通过创界通外观设计专利服务提交的外观设计专利注册是否成功取决于外观设计专利产品本身及申请时间等因素，并最终由目的国外观设计专利局依法审查后决定。创界通不会以任何明示或者暗示的方式担保您提交的外观设计专利注册申请能够成功，且对您的外观设计专利注册是否成功不承担法律有明确规定之外的责任。如果您要求百分之百的成功率或其他任何效果，创界通无法做出承诺，因此请您慎重考虑是否继续使用本服务。
</p>
<p class="MsoNormal">
	2.9 创界通有权对您提交的拟申请外观设计专利进行初步审核，如果认为申请外观设计专利的产品本身或外观设计专利申请行为不合法或不符合外观设计专利注册申请约定，创界通有权随时终止本次外观设计专利申请服务。
</p>
<p class="MsoNormal">
	2.10 外观设计专利注册为单次服务，如您在外观设计专利审查过程中需要提起不予补正答复、注册复审、驳回复审、缴纳授权等，或需要对已申请注册的外观设计专利改变外观设计的，您均应另行购买相应的创界通服务。
</p>
<p class="MsoNormal">
	2.11 创界通有权根据业务策略，适时对外观设计专利注册服务的功能进行增加、删减、更新、调整，或取消本服务类型，具体以您使用服务当时创界通相关页面的展示为准。若您对创界通增加、删减、调整等的内容有异议的，应及时以书面形式告知创界通，并停止使用创界通外观设计专利服务；否则，将被视为您认可前述内容。
</p>
<p class="MsoNormal">
	2.12 您购买的商标和/或外观设计专利服务期限原则上为自付款之日起算一年，或至以下任何一项完成时止，两者取到期较早者，该期限与软件服务期限保持一致：
</p>
<p class="MsoNormal">
	1 ）目的国知识产权局更新了商标或专利注册号，注册成功，甲方收到乙方发送的电子 证书或纸质证书。
</p>
<p class="MsoNormal">
	2 ）申请目的国的知识产权局对该商标或专利下了最终无效通知。
</p>
<p class="MsoNormal">
	3 ）甲方书面放弃该商标或专利申请、未在申请目的国的知识产权局规定答复期限内做 出回应，导致超出申请时效的。
</p>
<p class="MsoNormal">
	<b><span>第</span>3条 服务使用规范</b>
</p>
<p class="MsoNormal">
	3.1 您理解并保证：
</p>
<p class="MsoNormal">
	3.1.1 您应对使用本服务过程中所提供的信息和材料的真实性和准确性负责；如因您故意或过失导致的信息错误，创界通有权暂停直至终止服务，由您自行承担全部责任及后果，创界通保留追究您法律责任的权利。
</p>
<p class="MsoNormal">
	3.1.2 您应向创界通提供完整、准确、可靠的联系方式（包括但不限于手机号码、电子邮件、联系地址或其他可供联系的详细信息），如服务过程中您的联系方式发生变化，您应及时在变更后两个工作日内通知创界通，以免影响本服务过程中信息和文件的传达。如因联系方式不准确造成的任何结果，均由您自行承担。
</p>
<p class="MsoNormal">
	3.2 您理解并保证：
</p>
<p class="MsoNormal">
	3.2.1 您应积极配合创界通为您提供本服务的相关事宜，您同意按照创界通提示的时间和要求，及时准确地提供、确认信息及材料并支付款项，如因您提供的信息或材料不及时、不准确，或未按照确认页面的价格按时支付款项，您需自行承担责任及后果（包括但不限于办理时间延期、申请被驳回等），创界通有权终止本服务。
</p>
<p class="MsoNormal">
	3.2.2 您成功支付费用，并不代表商标申请成功。商标最终能否成功申请取决于商标标志本身及申请时间等因素，并最终由商标局依法审查后决定。创界通对该商标是否申请成功，不承担法律有明确规定之外的责任。
</p>
<p class="MsoNormal">
	3.3 您理解并保证：
</p>
<p class="MsoNormal">
	3.3.1 您在使用本服务过程中的所有行为均应遵守国家法律、法规等相关规定，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本服务协议及创界通相关规则的约定，您的商标注册申请不是为了恶意或任何非法目的，不得故意抢注或刻意模仿他人商标或存在其他侵犯他人知识产权的行为，不得无使用目的大量囤积商标。如您违反前述承诺，创界通有权随时终止本服务，您应以自己的名义独立承担所有法律责任，并确保本平台免于因此产生任何损失。如因您使用本服务的行为给本平台及创界通造成损失的，您应承担全部赔偿责任。
</p>
<p class="MsoNormal">
	3.3.2 创界通仅为您提供咨询建议，以及代为向登记机关递交您的申请材料，该行为不能被视为创界通对您提供的材料内容的任何认同、保证或担保。您应对提供的材料内容独立承担全部责任，如材料内容不真实、不准确或存在其他不当内容，您应独立承担一切法律责任且应保证创界通不因此被任何第三方追究责任或受到任何其他损害，如因此给创界通带来损失，由您承担全部责任。
</p>
<p class="MsoNormal">
	3.4 创界通不会审查您使用商标和/或外观设计专利申请服务的意图，您使用本服务的行为不应使创界通陷入任何不利或纠纷之中。如因您通过本服务申请商标服务的行为给创界通造成损失的，您应承担相应的责任。
</p>
<p class="MsoNormal">
	3.5 商标和/或外观设计专利注册成功之后，您因持有或使用注册商标和/或外观设计专利而引起的任何纠纷或损失，与本平台无关。同时，您有义务保护本平台及创界通免于受到任何因您持有或使用此商标和/或外观设计专利而引起的第三方诉讼、索赔或其他行为而造成的损害。
</p>
<p class="MsoNormal">
	<b><span>第</span>4条 服务费用</b>
</p>
<p class="MsoNormal">
	4.1 服务费报价和申请官方规费标准请至相应页面查询（创界通有权随时依市场行情、相关国家知识产权局官方规费调整及其他相关因素，调整服务费和申请官方规费标准，服务费自调整之次日起生效、官方规费自各国国家知识产权局规定之生效日起适用）。
</p>
<p class="MsoNormal">
	4.2 您可就已支付的服务费用，向本平台申请相应金额的发票，并承担开具发票需要的税点金额。
</p>
<p class="MsoNormal">
	4.3 创界通将在官网相关页面公示有关收费标准和缴费要求，并有权根据业务需要和市场变化等原因，调整上述标准和要求；或者根据当时的市场状况及自身经营政策等因素，制定不同的服务收费标准、优惠与促销政策等。
</p>
<p class="MsoNormal">
	4.4 创界通会定期或不定期推出优惠活动或政策。您理解并确认：
</p>
<p class="MsoNormal">
	4.4.1 此类优惠活动或政策均为创界通在正常服务价格之外的一次性特别优惠，创界通不保证您一定可以享受该等特别优惠。
</p>
<p class="MsoNormal">
	4.4.2 在优惠活动或优惠政策期间新购买本服务的可享受特别优惠，此前已购买的不可返还差价。
</p>
<p class="MsoNormal">
	4.4.3 除非创界通以书面形式给予明确说明，通常情况下，多种优惠不可同时叠加适用。
</p>
<p class="MsoNormal">
	4.4.4若付款方与订单主体不一致时，付款方付款即视为已受订单主体委托代为付款。本平台向您开具的发票将以开票主体信息应与订单签约主体保持一致。
</p>
<p class="MsoNormal">
	<b><span>第</span>5条 服务验收</b>
</p>
<p class="MsoNormal">
	<span>在创界通完成各类案件申请或法律文件准备后，您应及时对相关文件进行验收，并确认是否送件至各国</span>/地区知识产权局。
</p>
<p class="MsoNormal">
	<b><span>第</span>6条 用户退款规则</b>
</p>
<p class="MsoNormal">
	您知悉并确认仅符合如下条件之一，创界通才会将您支付的相关服务费全部或部分退还给您：
</p>
<p class="MsoNormal">
	① 由于市场变化及各种因素的影响，创界通无法保证您提交的申请委托服务都能提供，如您拟购买的服务发生“暂时无法提供服务”的情况，您和创界通均有权取消订单，并全额退还已支付的案件相关费用。
</p>
<p class="MsoNormal">
	② 在您的委托还未正式提交给注册办理前，<span>在服务费用到达平台账户之日起</span>15天（含）以内，您申请退款平台将不收取手续费；服务费用到达平台账户之日起16<span>天</span><span>-</span>30天，按<span>服务费总额的</span>5%计取手续费；服务费到账后31<span>天</span>-90（含）天扣除10%手续费；服务费到账后90天以上<span>（不含</span><span>90天）</span><span>按服务费用总额的</span>20%计取手续费。
</p>
<p class="MsoNormal">
	③ 在您的知识产权案件委托提交给注册办理后，不再退还服务费以及已经发生的官方规费。
</p>
<p class="MsoNormal">
	④其他情况：如因您付款账户出现问题需申请退款，平台不接受此类情况的退款申请，您支付服务费用前须确定付款账户。
</p>
<p class="MsoNormal">
	<b><span>第</span>7条 保证条款</b>
</p>
<p class="MsoNormal">
	您保证不以任何理由、任何方式自行寻求专利代理机构的任何专家为您私下提供服务，除非经创界通书面同意。一经发现，创界通有权注销（永久冻结）您及该专家的帐户，如给创界通造成任何损失，创界通有权向您索赔。
</p>
<p class="MsoNormal">
	<b><span>第</span>8条 用户账号规则</b>
</p>
<p class="MsoNormal">
	8.1 您在注册或使用平台服务时可能需要提供一些必要的信息。您须保证所填写及所提供的资料真实、准确、完整，否则可能无法使用平台服务，或在使用过程中受到限制，甚至影响您是否能够使用平台特定功能。对于因您提供的信息不真实、不准确或不完整导致的责任和损失由您承担。
</p>
<p class="MsoNormal">
	8.2 平台有权根据您所提供资料的真实性、准确性、完整性以及是否符合平台服务规定的其他条件，决定是否为您提供服务。您在使用平台服务过程中，所提供的信息发生变动，应及时进行变更。
</p>
<p class="MsoNormal">
	8.3 您注册成功后，我们将为您配置账号，该账号之所有权归平台所有，用户在本协议有效期内仅享有使用权。未经平台同意，用户的账号仅供用户本人使用，账号信息和权限不得以转让、赠与、借用、售卖、授权或租用等方式许可给第三方使用或和第三方共同控制、使用。
</p>
<p class="MsoNormal">
	8.4如果您需要注销您的账号，您有权通过平台公布的方式、程序进行，我们将在核实您的身份并清理账号资产（例如已充值或已获得的虚拟资产等）及纠纷争议后，为您提供账号注销服务。在注销账号之后本协议即终止，我们将停止为您提供任何服务。同时对您的平台的所有数据将不做保存。当然，我们也保留权利在您的账号符合回收的如下情况下，直接回收并注销您的账号并停止服务：（1）未通过实名认证；（2）其他情况。
</p>
<p class="MsoNormal">
	8.5 用户一经注册，即可能可以在平台及我们关联公司运营的其他产品，或者合作伙伴等第三方平台中通行使用。在使用平台服务账号登录并使用其他产品或服务时，除遵守本协议约定外，还应遵守该等产品的服务协议的约定。平台服务和其他产品对可能出现的纠纷在法律规定和约定的范围内各自承担责任。
</p>
<p class="MsoNormal">
	8.6为客户体验及功能服务考虑，您在使用不同服务时被要求填写的信息内容可能不完全一致，因此，为了给您提供更好的服务及为了您的登录账号安全，可能需要您补充完整信息后方可使用。
</p>
<p class="MsoNormal">
	8.7您有责任自行负责保管账号的用户名和密码等信息，否则因该等事项引发的法律责任由用户自行承担。凡使用平台服务登录账号和登录凭证的行为，平台服务视为您本人的操作，操作所产生的电子信息记录均为平台服务用户行为的有效凭据。
</p>
<p class="MsoNormal">
	8.8 出现以下情况时，创界通有权直接以注销账户的方式终止本协议：
</p>
<p class="MsoNormal">
	8.8.1创界通终止向您提供服务后，您涉嫌再一次直接或间接或以他人名义注册为创界通用户的；
</p>
<p class="MsoNormal">
	8.8.2您提供的电子邮箱、手机号码、微信号、QQ号等不存在或无法接收相关信息，且没有其他方式可以与您进行联系，或创界通以其它联系方式通知您更改电子邮件信息，而您在创界通通知后三个工作日内仍未更改为有效的电子邮箱的；
</p>
<p class="MsoNormal">
	8.8.3您注册信息中的主要内容不真实或不准确或不及时或不完整；
</p>
<p class="MsoNormal">
	8.8.4本协议变更时，您明示并通知创界通不愿接受新的服务协议的；
</p>
<p class="MsoNormal">
	8.8.5其它创界通认为应当终止服务的情况。
</p>
<p class="MsoNormal">
	8.9 您有权向创界通要求注销您的账户，经创界通审核同意的，创界通注销（永久冻结）您的账户，届时，您与创界通基于本协议的合同关系即终止。您的账户被注销（永久冻结）后，创界通没有义务为您保留或向您披露您账户中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。
</p>
<p class="MsoNormal">
	8.10 您同意，您与创界通的合同关系终止后，本平台仍享有下列权利：
</p>
<p class="MsoNormal">
	8.10.1继续保存您的注册信息及您使用创界通平台服务期间的所有信息。
</p>
<p class="MsoNormal">
	8.10.2您在使用创界通平台服务期间存在违法行为或违反本协议和/或规则的行为的，创界通仍可依据本协议向您主张权利。
</p>
<p class="MsoNormal">
	8.11 如果您是创界通平台的非付费用户，且连续十二个月没有登陆本网站，本网站有权注销您的帐号。
</p>
<p class="MsoNormal">
	<b><span>第</span>9条 用户行为规范</b>
</p>
<p class="MsoNormal">
	9.1 您保证合理地使用平台服务，并接受本协议和我们适时制定并发布的其他政策、规则、公告声明。
</p>
<p class="MsoNormal">
	9.2 行为禁止：您可在本协议约定的范围内使用平台及服务，您不得利用平台从事以下行为：
</p>
<p class="MsoNormal">
	<span>（</span>1）超出授权或恶意使用平台服务；
</p>
<p class="MsoNormal">
	<span>（</span>2）利用平台发表、传送、传播、储存危害国家安全、国家统一、社会稳定的内容，或侮辱诽谤、色情、暴力、引起他人不安及任何违反国家法律法规政策的内容，或者设置含有上述内容的网名、角色名，发布、传送、传播违法广告信息、营销信息及垃圾信息等；
</p>
<p class="MsoNormal">
	<span>（</span>3）利用平台侵害他人知识产权、肖像权、隐私权、名誉权、个人信息等合法权利或权益；
</p>
<p class="MsoNormal">
	<span>（</span>4）恶意虚构或协助虚构事实、评价等信息或数据；
</p>
<p class="MsoNormal">
	<span>（</span>5）进行任何危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/账户；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试本“软件”系统或网络的弱点或其他实施破坏网络安全的行为；企图干涉、破坏本“软件”系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造TCP/IP数据包名称或部分名称；利用平台及服务上传任何病毒、木马，或者蠕虫等危害网络健康的内容；
</p>
<p class="MsoNormal">
	<span>（</span>6）对平台进行反向工程、反向编译或反向汇编或以其他方式企图发现平台的源代码和算法，未经许可修改、禁用软件的任何功能或创建基于软件的衍生作品。去除平台或文档上的任何所有权声明或标签，或将其他软件与平台合并；
</p>
<p class="MsoNormal">
	<span>（</span>7）进行任何破坏我们提供服务公平性或者其他影响应用正常秩序的行为，如主动或被动刷分、合伙作弊、使用外挂或者其他的作弊软件、利用BUG（又叫“漏洞”或者“缺陷”）来获得不正当的非法利益，或者利用互联网或其他方式将外挂、作弊软件、BUG公之于众；
</p>
<p class="MsoNormal">
	<span>（</span>8）从事其他法律法规、政策及公序良俗、社会公德禁止的行为以及侵犯其他个人、公司、社会团体、组织的合法权益的行为。
</p>
<p class="MsoNormal">
	9.3 信息内容规范：为了营造良好网络生态，保障公民、法人和其他组织的合法权益，维护国家安全和公共利益，我们将根据《中华人民共和国国家安全法》《中华人民共和国网络安全法》《互联网信息服务管理办法》等法律、行政法规，自觉践行社会主义核心价值观，营造清朗的网络空间，并开展的弘扬正能量、处置违法和不良信息等相关活动。
</p>
<p class="MsoNormal">
	9.4 信息内容的使用规范
</p>
<p class="MsoNormal">
	9.4.1 未经我们书面许可，您不得自行或授权、允许、协助任何第三人对平台中信息内容进行如下行为：
</p>
<p class="MsoNormal">
	<span>（</span>1）复制、读取、采用平台的信息内容，用于任何形式的商业用途；
</p>
<p class="MsoNormal">
	<span>（</span>2）擅自编辑、整理、编排平台及相关服务的信息内容后在平台及相关服务的源页面以外的渠道进行展示；
</p>
<p class="MsoNormal">
	<span>（</span>3）采用不正当方式，自行或协助第三人对平台及相关服务的信息内容产生流量、阅读量或交易引导、转移、劫持等不利影响。
</p>
<p class="MsoNormal">
	<b><span>第</span>10条 个人信息保护与隐私政策</b>
</p>
<p class="MsoNormal">
	10.1 尊重用户隐私并保护您的个人信息安全是我们的一贯态度，平台将会采取合理的措施保护您的个人信息与隐私。我们承诺，除非获得用户同意，平台不会收集、使用其提供服务所必需以外的用户个人信息或者将信息用于提供服务之外的目的。但是平台因需要向知识产权注册/申请国政府及税局等机关提交资料的情形除外。
</p>
<p class="MsoNormal">
	10.2 在您使用本平台的过程中，平台将遵循合法、正当、必要的原则，收集您的相关信息，包括但不限于：
</p>
<p class="MsoNormal">
	<span>（</span>1）用户注册或登录的账户信息，例如用户注册账户使用的电话号码、姓名或昵称、公司名等信息；
</p>
<p class="MsoNormal">
	<span>（</span>2）用户用于办理商标和/或外观设计专利申请服务上传的信息，例如用户的营业执照、销售数据等用户主动填写的信息或用户与平台客服联系时提供的相关信息等；
</p>
<p class="MsoNormal">
	<span>（</span>3）用户使用平台过程中产生的信息。平台会根据用户授予的权限，接收并记录用户所使用的设备相关信息，例如设备属性信息、设备位置信息、设备连接信息等；
</p>
<p class="MsoNormal">
	<span>（</span>4）平台根据用户授权通过合法方式收集的其他用户信息。
</p>
<p class="MsoNormal">
	10.3 安全保护：我们将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息及隐私安全，以免遭受未经授权的访问、使用或披露。
</p>
<p class="MsoNormal">
	10.4 信息使用与披露：我们有权在遵守法律法规的前提下，以明示的方式获取、使用、储存和分享您的个人信息。我们不会在未经您授权时，公开、编辑或透露您的个人信息及您保存在我们的非公开内容。您同意并保证：平台有权根据我们制定的个人信息保护规则收集使用您的相关信息。
</p>
<p class="MsoNormal">
	10.5 您同意，我们有权通过cookie等技术收集您的使用、行为信息，并在经过数据脱敏使之不再指向、关联到您个人的身份信息时，自由使用脱敏后的纯商业数据。当然，您也可根据自己的偏好删除Cookie，但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。目前删除Cookie的一般路径是浏览器：“设置-清除数据”，或者将手机系统还原/清除。
</p>
<p class="MsoNormal">
	10.6 在遵守本协议项下特别约定的个人信息保护与隐私政策外，我们希望您认真并完整阅读我们特别针对平台而制定并适时发布的《隐私政策》，这将更有助于保障您的个人信息。
</p>
<p class="MsoNormal">
	<b><span>第</span>11条 信息或广告推送</b>
</p>
<p class="MsoNormal">
	11.1 您同意在接受我们提供服务的同时，允许我们在遵守法律法规的前提下自行或由第三方广告商向您发送、展示广告、推广或宣传信息（包括商业与非商业信息）。如您对发送、推荐的广告或信息不感兴趣，您可以基于我们提供的相关技术选项，控制系统向您展示或不展示/减少展示相关类型的广告或信息。
</p>
<p class="MsoNormal">
	<b><span>第</span>12条 知识产权</b>
</p>
<p class="MsoNormal">
	12.1 在本服务协议，创界通向您提供的任何资料、技术或技术支持、软件、服务等的知识产权均属于提供创界通或其合法权利人所有；除创界通或合法权利人明示同意外，您无权复制、传播、转让、许可或提供他人使用上述知识成果，否则应承担相应的责任。
</p>
<p class="MsoNormal">
	12.2 您应保证提交给创界通的信息和材料、对本服务的使用以及使用本服务所产生的成果，未侵犯任何第三方的合法权益。创界通应保证向您提供的服务不违反现行有效的法律法规。
</p>
<p class="MsoNormal">
	12.3 如果第三方机构或个人对您使用本服务过程中的知识产权的归属提出质疑或投诉，您和创界通均有责任出具相关知识产权证明材料，并配合对方的相关投诉处理工作。对于因此引起的索赔、诉讼或可能向其提起诉讼，您应负责解决，承担费用和损失，以及使本平台及创界通免责。
</p>
<p class="MsoNormal">
	<b><span>第</span>13条 免责声明</b>
</p>
<p class="MsoNormal">
	13.1 我们对于您自平台而获得的所有他人、第三方的信息、内容或者广告宣传等任何资讯（以下统称“信息”），除法律明确规定外，不保证真实、准确和完整性。如果任何单位或者个人通过上述“信息”而进行任何行为，您须自行甄别真伪和谨慎预防风险。您在接受平台及服务时，有可能会接触到令人不快、不适当或令人厌恶的内容，在任何情况下，我们均不对任何此等内容承担任何责任。无论何种原因，我们不对任何非与我们直接发生的交易或行为承担任何直接、间接、附带或衍生的损失和责任。
</p>
<p class="MsoNormal">
	13.2 鉴于互联网服务的特殊性，您理解并同意我们在以下情况下无需对您所遭受的损失（包括但不限于财产、收益、数据资料等方面的损失或其他无形损失）承担责任：
</p>
<p class="MsoNormal">
	<span>（</span>1）因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素导致平台及服务障碍不能正常运作；
</p>
<p class="MsoNormal">
	<span>（</span>2）由于计算机病毒、木马、其他恶意程序、黑客攻击、电信部门及网络运营公司技术调整或故障、系统维护等意外原因而造成平台及服务中断或延迟。
</p>
<p class="MsoNormal">
	13.3 平台有权不时对提供的所有服务实施优惠政策或开展优惠活动，该等优惠政策或优惠活动以平台发布的实时信息为准，您知悉并认可，平台有权自行决定是否提供优惠政策或开展优惠活动，以及优惠政策或优惠活动的内容、条件和有效期，并不时进行调整。对于不同活动期内不同的价格，平台不允诺担保您享有的是最低服务价格。
</p>
<p class="MsoNormal">
	13.4 有限责任：平台在适用法律所允许的最大范围内，不论出于何种原因，平台对您的全部责任为您使用本平台产品和服务而向平台支付的费用总额。如果平台免费向您提供了服务，则平台无义务对您承担任何赔偿责任。任何情况下，平台不对出自本协议或与本协议有关的或与平台的运行有关的任何特殊的、偶然的、惩罚性或间接的损害（包括但不限于数据损失、利润损失或营业损失）或采购替代产品承担责任，不论该等责任是基于合同、担保、侵权（包括过失）、严格责任或其他，也不论平台是否被事先告知了损失或损害发生的可能性。即使本协议约定的有限补救措施未能实现其根本目的，前述的责任限制依然适用。
</p>
<p class="MsoNormal">
	13.5 如果您通过合法方式获得了相关付费服务的优惠券或折扣等其他优惠方式的，则用户知悉并认可，该等优惠券或折扣必须满足一定条件才能使用，以优惠券上的信息提示和优惠券使用说明或平台公示的折扣使用说明为准。优惠券或折扣不兑现（即不直接兑换现金）、不找零（即订单金额不足抵用券金额的，抵用券剩余金额无效）、过期作废；优惠券或折扣仅限同一用户账号使用，严禁出售、转让或共享，如经平台发现存在出售、转让或共享优惠券或折扣等其他优惠方式的，该优惠券或折扣将予以作废处理，且平台有权视情节严重程度予以封号处理，并保留追究相关责任人法律责任的权利。
</p>
<p class="MsoNormal">
	13.6 免责：如因下所列任何原因而造成的用户资料泄露、丢失、被盗用或被篡改等，平台均有权获得免责：
</p>
<p class="MsoNormal">
	<span>（</span>1）任何因政府管制而造成的暂时性关闭等影响网络正常浏览的不可抗力原因；
</p>
<p class="MsoNormal">
	<span>（</span>2）任何计算机系统问题、黑客攻击、计算机病毒侵入或发作的原因；
</p>
<p class="MsoNormal">
	<span>（</span>3）任何因网络安全问题导致的账户或银行卡信息泄露，该风险可能会给用户造成经济损失，用户承诺自行承担向侵权方追究责任及追究责任不能的后果；
</p>
<p class="MsoNormal">
	<span>（</span>4）任何因用户个人原因导致的用户资料泄露、丢失、被盗用或被篡改等；
</p>
<p class="MsoNormal">
	<span>（</span>5）其他不能归责于公司的原因。
</p>
<p class="MsoNormal">
	<b><span>第</span>14条 保密条款</b>
</p>
<p class="MsoNormal">
	14.1本协议所称“商业秘密”包括：有关产业、商业、产品、技术、市场、业务信息与数据以及所有方法、工具、流程、专业技能等，但不包括下列事项：
</p>
<p class="MsoNormal">
	14.1.1 一方于提供时，已属公开或众所周知者；
</p>
<p class="MsoNormal">
	14.1.2该资料自他人所取得，而该他人对资料未负有任何保密义务者；
</p>
<p class="MsoNormal">
	14.1.3非因任一方作为或不作为而成为众所周知者；
</p>
<p class="MsoNormal">
	14.1.4一方于提供前，已为他方所知悉且无保密义务者。
</p>
<p class="MsoNormal">
	14.2您同意因在知识产权申请委托中或进行其他创界通平台活动中而知悉创界通及其他第三方商业秘密者，应负保密责任，非经创界通或其他第三方之书面同意，不得以任何形式揭露、提供予他人或使他人取得创界通或其他第三方商业秘密。您并应采取必要措施，以防止商业秘密被窃或泄露。反之，创界通亦履行相同保密义务。
</p>
<p class="MsoNormal">
	14.3您必须保证，在创界通平台上传、发布或传播的内容未侵犯其他任何第三方之合法权益，否则将承担由此带来的一切法律责任。
</p>
<p class="MsoNormal">
	14.4您不得将任何内部资料、机密资料、涉及他人隐私资料或侵犯任何人的专利权、商标权、著作权、商业秘密或其他专属权利之内容加以上传、发布或传播。 若第三方认为您在创界通上传、发布或传播的内容侵犯其合法权益，且向创界通发出合理通知的，则创界通有权移除涉嫌侵权内容。
</p>
<p class="MsoNormal">
	<b><span>第</span>15条 违约责任</b>
</p>
<p class="MsoNormal">
	15.1 如果我们发现、收到他人举报或投诉您违反本协议约定或违反法律法规和国家有关规定的，我们有权采取警示、冻结、终止/中止/限制使用账号等功能、解除或终止本协议，或提出损害赔偿等措施。
</p>
<p class="MsoNormal">
	15.2 若您的行为给我们造成损失的（包括但不限于直接损失、名誉损失、第三方的罚款、索赔等），我们有权全额向您追偿，如您在平台中有保证金、虚拟货币等财产或优惠券等虚拟权益的，我们有权冻结。
</p>
<p class="MsoNormal">
	15.3 本协议终止后，除法律有明确规定外，平台无义务向您或您指定的第三方披露您账户中的任何信息。本协议终止后，平台仍享有下列权利：根据法律规定，继续保存您留存于平台的各类信息；对于您过往的违约行为，平台仍可依据本协议向您追究违约责任。
</p>
<p class="MsoNormal">
	<b><span>第</span>16条 法律适用、管辖及其他</b>
</p>
<p class="MsoNormal">
	16.1本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国大陆地区法律（不包括港澳台法律）。
</p>
<p class="MsoNormal">
	16.2因本协议产生之争议，本平台会与您沟通并处理。一旦产生之争议无法解决，双方均同意向协议签订地广东省深圳市南山区有管辖权的人民法院提起诉讼。
</p>
<p class="MsoNormal">
	<b><span>第</span>17条 如何联系我们</b>
</p>
<p class="MsoNormal">
	17.1如果您有任何的疑问、投诉、意见和建议，欢迎您与我们沟通反馈。我们的联系方式见下：
</p>
<p class="MsoNormal">
	<span>客服邮箱：</span>support@cjtglobal.com
</p>
<br />
</div>
</template>
<script>
export default {
   
};
</script>
<style lang="less" scoped>
 
.privacy-policy{
  max-width: 1200px;
  margin: 0px auto;
  padding:20px;
  font-size: 14px;
  line-height: 20px;
  .header{
    font-size: 16px;
    margin-bottom: 20px;
  }
}
 
</style>


// WEBPACK FOOTER //
// src/views/common/userAgreement.vue